import React from 'react'
import ReactDOM from 'react-dom'
import PrimaryMenuUserActions from './UserActions'

document.addEventListener("turbolinks:load", function(event) {
  let menuUserActions = document.getElementById("primary-nav-menu-user-actions")

  if (menuUserActions != undefined) {
    let props = JSON.parse(menuUserActions.dataset.props)


    props.current_user && ReactDOM.render(
      <PrimaryMenuUserActions
        current_user={props.current_user}
        links={props.links}
      />,
      menuUserActions
    );
  }
})
